<template>
  <v-select
    v-model="selectedItem"
    :items="items"
    :label="label"
    :hint="disabledHint"
    :disabled="disabled"
    item-text="name"
    data-testid="pay-variation-select"
    ref="selector"
    color="black"
    item-color="primary"
    persistent-hint
    return-object
  ></v-select>
</template>

<script>
import { PayOn, PayBy, AccountingCategory } from '@/utils/Enumerations.js'
export default {
  name: 'PayVariationSelector',

  data: () => ({
    selectedItem: null
  }),

  props: {
    initialValue: { type: Number, default: 0 },
    accountingCategory: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'PayBy' },
    isLogsContract: { type: Boolean, default: true },
    propItems: { type: Array, default: undefined },
    payByValue: { type: Number, default: null }
  },

  watch: {
    selectedItem (val) {
      const eventName = this.type === 'PayBy' ? 'pay-by-chosen' : 'pay-on-chosen'
      this.$emit(eventName, val.value)
    },

    initialValue: {
      handler (newVal) {
        this.selectedItem = this.type === 'PayBy' ? PayBy.forInt(newVal) : PayOn.forInt(newVal)
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    items () {
      if (this.propItems) return this.propItems
      return this.type === 'PayBy'
        ? PayBy.enums.filter(payBy => payBy !== PayBy.MetricWeight || this.accountingCategory === AccountingCategory.Receivable.value)
        : PayOn.enums.filter(payOn => {
          const isDefectType = payOn === PayOn.Defect || payOn === PayOn.NatureDefect || payOn === PayOn.MismanufacturedDefect
          if (this.payByValue === PayBy.Volume.value && isDefectType) return false
          return (payOn !== PayOn.NotApplicable || this.disabled) &&
            (!isDefectType || (this.accountingCategory === AccountingCategory.Payable.value && this.isLogsContract))
        })
    },

    label () {
      return this.type === 'PayBy' ? this.$t('payBy') : this.$t('payOn')
    },

    disabledHint () {
      if (this.type === 'PayOn' && this.disabled) return this.$t('disPayVariationHint')
      else return ''
    }
  }
}
</script>
